import React, {useEffect, useState} from 'react'
import style from './index.module.scss'
import { DropDown } from '../../../components/JurosCompostos/DropDown'
import KeyboartReturn from './keyboardReturn.svg'
import TimeLine from './timeLine.svg'
import formatCurrency from '../../../utils'
import ApiSuno from '../../../api/services/ApiSuno'
import { TooltipError } from '../../JurosCompostos/TooltipError'

export const Investiments = (props) => {
    const apiSuno = new ApiSuno();
    const [investimentsList, setInvestimentsList] = useState([])
    const [investimentsElement, setInvestimentsElement] = useState([])
    
    const droplistRentability = [{id:1, label:'% Selic'},
        {id:2, label:'IPCA +'},
        {id:3, label:'Pré Fixado'},
        {id:4, label:'CDI'}]

    const droplistInvestType = [
        {id:1, label:'CDB', tax: true},
        {id:2, label:'LC', tax: true},
        {id:3, label:'Tesouro', tax: true},
        {id:4, label:'Debênture', tax: true},
        {id:5, label:'LCI', tax: false},
        {id:6, label:'LCA', tax: false},
        {id:7, label:'Debênture incentivada', tax: false},
        {id:8, label:'CRI', tax: false},
        {id:9, label:'CRA', tax: false}
    ]

    useEffect(()=>{
        props.onChange(investimentsList)
        if(investimentsList.length === 0){
            addInvestiment()
        } else {
            let newElements = []
            investimentsList.forEach((item)=>{
                newElements.push(createElement(item, true))
            })
            setInvestimentsElement(newElements)
        }
    }, [investimentsList])

    useEffect(()=>{
        if(props.valid === false){
            let newInvestiments = []
            let valid = true
            investimentsList.forEach(investiment=>{
                if(valid && isValid(investiment) === false){
                    newInvestiments.push(createElement(investiment, false))
                    valid = false
                } else {
                    newInvestiments.push(createElement(investiment, true))
                }
            })
            setInvestimentsElement(newInvestiments)
        }
    }, [props.valid])

    function isValid(investiment){
        if(investiment.rentabilitySelected.id === 1 || investiment.rentabilitySelected.id === 3 || investiment.rentabilitySelected.id === 4){
            if(investiment.rentabilityValue === 0){
                return false
            }
        }
        return true
    }

    function handleTextChange (value, id){
        if(value === '' || value.length === 1){
           value = '0,00%' + value
        }
        if(value[value.length-1] !== '%'){
            if(isNaN(value[value.length-1])){
                value = value.slice(0, -1)
            }
        }
        if(!value.includes('%')){
            value = value.slice(0, -1)
        }
        value = value.replaceAll('%', '').replaceAll(',', '').replaceAll('.', '')
        let newValue = parseFloat(value.slice(0, value.length-2)+'.'+value.slice(value.length-2))
        let newInvestType = []
        investimentsList.map((item)=>{
            let newValues = item
            if(item.id === id){
                newValues.rentabilityValue = newValue
            }
            newInvestType.push(newValues)
        })
        setInvestimentsList(newInvestType)
    }

    function handleInvestTypeChange(value, id){
        let newSelected = droplistInvestType.find(item=>item.id === parseInt(value))
        let newInvestType = []
        investimentsList.map((item)=>{
            let newValues = item
            if(item.id === id){
                newValues.investimentTypeSelected = newSelected
            }
            newInvestType.push(newValues)
        })
        setInvestimentsList(newInvestType)
    }

    function handleRentabilityChange(value, id){
        let newSelected = droplistRentability.find(item=>item.id === parseInt(value))
        let newInvestType = []
        investimentsList.map((item)=>{
            let newValues = item
            if(item.id === id){
                newValues.rentabilitySelected = newSelected
            }
            newInvestType.push(newValues)
        })
        setInvestimentsList(newInvestType)
    }

    function createElement(element, valid){
        return <div key={element.id} className={style.investiments}>
            <div className={style.dropDown}>
                <DropDown 
                    list={getInvestimentType(-1)}
                    selected={element.investimentTypeSelected}
                    onChange={(value)=>{handleInvestTypeChange(value, element.id)}}
                    customStyle={{borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'}}
                />
            </div>
            <div style={{position: 'relative'}}>
            <div className={style.valueInput}>
                <div className={style.dropDown}>
                    <DropDown 
                        list={droplistRentability}
                        selected={element.rentabilitySelected}
                        onChange={(value)=>{handleRentabilityChange(value, element.id)}}
                        customStyle={{borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'}}
                    />
                </div>
                <div className={style.inputfield}>
                    <input 
                        className={style.textinput} 
                        onChange={(value)=>handleTextChange(value.target.value, element.id)}
                        value={setMask(element.rentabilityValue)}
                        type="tel"
                        />
                </div>
            </div>
                    {(valid)?
                        null
                    :<TooltipError style={{marginTop: '5px', top: "100%"}} text={props.errorMessage} rightArrow={true}/>}
                </div>
            <div className={style.button} onClick={()=>removeInvestiment(element)}>
                X
            </div>
        </div>
    }

    function addInvestiment(){
        let investments = Object.assign([], investimentsList)
        let newInvestType = getInvestimentType(-1)
        let newRentability = getRentability(-1)
        investments.push({
            id: new Date().getTime(),
            investimentTypeSelected: newInvestType[newInvestType.length-1],
            rentabilitySelected: newRentability[newRentability.length-1],
            rentabilityValue: 0
        })
        setInvestimentsList(investments)
    }

    function removeInvestiment(element){
        if(investimentsList.length > 1){
            let investiments = Object.assign([], investimentsList)
            investiments.splice(investiments.findIndex((i)=>i.id === element.id), 1)
            setInvestimentsList(investiments)
        }
    }

    // Retorna os Tipos de Investimentos não selecionados nos dropDowns
    function getInvestimentType(id){
        let listReturn = Object.assign([], droplistInvestType)
        investimentsList.map((item)=>{
            if(parseInt(item.id) !== parseInt(id)){
                listReturn.splice(listReturn.findIndex(i=>parseInt(i.id) === parseInt(item.investimentTypeSelected.id)), 1)
            }
        })
        return listReturn
    }

    // Retorna as Rentabilidades não selecionadas nos dropDowns filtrando pelo id
    function getRentability(id){
        let listReturn = Object.assign([], droplistRentability)
        investimentsList.map((item)=>{
            if(parseInt(item.id) !== parseInt(id)){
                listReturn.splice(listReturn.findIndex(i=>parseInt(i.id) === parseInt(item.rentabilitySelected.id)), 1)
            }
        })
        return listReturn
    }

    function setMask(value){
        return formatCurrency(value)+'%'
    }

    return (
        <div className={style.main}>
            {investimentsElement}
            <div className={style.options}>
                {(investimentsList.length < 3)?<div className={style.option} onClick={addInvestiment}>
                    <KeyboartReturn fill={'#999999'} />
                    <div className={style.textSmallMobile}>Incluir nova linha</div>
                </div>
                :<div />
                }
                <div className={style.option} onClick={props.advancedButton}>
                    <TimeLine fill={'#999999'} />
                    <div className={style.text}>Modo avançado</div>
                </div>
            </div>
        </div>
    )
}